import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { InputTimeMaskWebElement } from './InputTimeMaskWebElement';
export { InputTimeMaskWebElement };

/**
 * Retrieve an instance of [InputTimeMaskWebElement](../classes/InputTimeMaskWebElement.html).
 * @example
 * ```javascript
 * import { findInputTimeMask } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findInputTimeMask(driver, By.id('my-oj-c-input-time-mask'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findInputTimeMask(
  driver: DriverLike,
  by: By
): Promise<InputTimeMaskWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type InputTimeMaskWebElement
  if (!(webEl instanceof InputTimeMaskWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'InputTimeMaskWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findInputTimeMask(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${InputTimeMaskWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-input-time-mask', InputTimeMaskWebElement);
